import { Component } from '@lisergia/core'

export default class extends Component {
  declare element: HTMLElement
  declare placeholder: HTMLElement
  declare ticking: boolean

  constructor({ element }: { element: HTMLElement }) {
    super({
      element,
    })

    this.ticking = false
  }

  createPlaceholder() {
    this.placeholder = document.createElement('div')
    this.placeholder.style.display = 'none'
    this.element.parentNode?.insertBefore(this.placeholder, this.element.nextSibling)
  }

  onScroll = () => {
    if (this.ticking) return

    this.ticking = true

    requestAnimationFrame(() => {
      this.update()
      this.ticking = false
    })
  }

  update() {
    const placeholderRect = this.placeholder.getBoundingClientRect()
    const isSticky = this.element.hasAttribute('data-sticky-active')

    if (!isSticky) {
      const elementRect = this.element.getBoundingClientRect()

      if (elementRect.bottom > window.innerHeight) {
        this.stick()
      }
    } else {
      if (placeholderRect.bottom <= window.innerHeight) {
        this.unstick()
      }
    }
  }

  stick() {
    this.placeholder.style.display = 'block'
    this.placeholder.style.height = `${this.element.offsetHeight}px`
    this.element.setAttribute('data-sticky-active', '')
  }

  unstick() {
    this.element.removeAttribute('data-sticky-active')
    this.placeholder.style.display = 'none'
  }

  addEventListeners() {
    this.createPlaceholder()
    window.addEventListener('scroll', this.onScroll, { passive: true })
    this.update()
  }

  removeEventListeners() {
    window.removeEventListener('scroll', this.onScroll)
  }
}
